import React, { Component } from "react";
import { Card, Space } from 'antd';
import { connect } from "react-redux";
import Server from "../Server.js";
import Header from "../Header.js";
import { Route, Link, Navigate } from "react-router-dom";
import { Toast } from "primereact/toast";
import { ProgressSpinner } from "primereact/progressspinner";


class ReserveList extends React.Component {
  constructor(props) {
    super(props);
    this.Server = new Server();
    this.toast = React.createRef();
    this.state = {
      absoluteUrl: this.Server.getAbsoluteUrl(true),
      url: this.Server.getUrl(),
      ShowLoading: true,
      list: []
    };
  }

  componentDidMount() {
    this.GetReserve();
  }


  GetReserve() {
    let that = this;
    let param = {
      token: localStorage.getItem("api_token"),
      active: true,
    };
    let SCallBack = function (response) {
      that.setState({
        list: response.data.result,
        ShowLoading: false
      });
    };
    let ECallBack = function (error) {
      
    };
    this.Server.send("AdminApi/GetReserve", param, SCallBack, ECallBack, null, true);
  }

  render() {
    if (this.state.page) {
      return <Navigate to={this.state.page} />;
    }
    return (
      <div style={{ height: "100%" }}>
        <Header ComponentName="رزرو ویلا" close={this.state.bankCallBack ? true : false} />
        <Toast
          ref={this.toast}
          position="top-right"
          style={{ fontFamily: "iranyekanwebmedium", textAlign: "right" }}
        />
        {!this.state.ShowLoading ? (
            <Space direction="vertical" size={16} style={{width:'100%',textAlign:'right'}}>
              {this.state.list.map((item)=>{
                return(
                  <Link
                  to={`${process.env.PUBLIC_URL}/Reserve?number=${item.number}`}
                >
                   <Card title={
                    <div>
                      <p>{item.name}</p>
                      <div style={{fontSize:13,fontWeight:'100'}}>شروع قیمت از : {item.price.toString()
                            .replace(/,/g, "")
                            .replace(/\B(?=(\d{3})+(?!\d))/g, ",")} ریال</div>
                    </div>} style={{width: "100%"}}>
                    
                    <img
                        src={
                          this.state.absoluteUrl +
                          (item.pic
                            ? item.pic?.split("public")[1]
                            : "nophoto.png")
                        }
                        style={{
                          borderRadius: 12,
                          whiteSpace: "pre-wrap",
                          maxHeight: 220,
                          width: "100%",
                        }}
                      />
                    </Card>
                  </Link>
                )
              })}
           
            </Space>
        ) : (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: "100%",
            }}
          >
            <ProgressSpinner
              style={{ width: "50px", height: "50px" }}
              strokeWidth="2"
              fill="var(--surface-ground)"
              animationDuration=".5s"
            />
          </div>
        )}
      </div>
    );
  }
}
function mapStateToProps(state) {
  return {
    username: state.username,
    password: state.password,
    ip: state.ip,
    account: state.account,
    place: state.place,
    fullname: state.fullname,
    tokenrb: state.tokenrb,
    mobile: state.mobile,
    appData: state.appData,
    systemId: state.systemId,

  };
}
export default connect(mapStateToProps)(ReserveList);
